"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var typography_1 = require("../typography");
var spacing_1 = require("../spacing");
var layout_1 = require("../../util/layout");
var utils_1 = require("./utils");
var SelectStyle = (0, styled_components_1.default)(spacing_1.Div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  cursor: pointer;\n\n  select {\n    -moz-appearance: none; /* Firefox */\n    -webkit-appearance: none; /* Safari and Chrome */\n    appearance: none;\n    ", "\n    padding-right: ", ";\n\n    /* prevent horizontal scroll on iOS Safari */\n    max-width: 100%;\n    overflow: hidden;\n\n    text-overflow: ellipsis;\n    cursor: pointer;\n  }\n\n  option {\n    ", ";\n    ", "\n    padding: ", ";\n  }\n\n  svg {\n    position: absolute;\n    right: ", ";\n    top: 50%;\n    margin-top: -3px;\n    pointer-events: none;\n  }\n"], ["\n  position: relative;\n  cursor: pointer;\n\n  select {\n    -moz-appearance: none; /* Firefox */\n    -webkit-appearance: none; /* Safari and Chrome */\n    appearance: none;\n    ", "\n    padding-right: ", ";\n\n    /* prevent horizontal scroll on iOS Safari */\n    max-width: 100%;\n    overflow: hidden;\n\n    text-overflow: ellipsis;\n    cursor: pointer;\n  }\n\n  option {\n    ", ";\n    ", "\n    padding: ", ";\n  }\n\n  svg {\n    position: absolute;\n    right: ", ";\n    top: 50%;\n    margin-top: -3px;\n    pointer-events: none;\n  }\n"])), utils_1.inputStyle, (0, layout_1.space)(4), function (_a) {
    var theme = _a.theme;
    return "font-family: ".concat(theme.typography.baseType);
}, typography_1.rulesForTextProps, (0, layout_1.space)(1), (0, layout_1.space)(1));
exports.Select = react_1.default.forwardRef(function (_a, ref) {
    var styledProps = _a.styledProps, options = _a.options, nativeProps = __rest(_a, ["styledProps", "options"]);
    return (react_1.default.createElement(SelectStyle, __assign({}, styledProps),
        react_1.default.createElement("select", __assign({ ref: ref }, nativeProps), options.map(function (o) { return (react_1.default.createElement("option", { key: o.value, value: o.value }, o.label !== undefined ? o.label : o.value)); })),
        react_1.default.createElement("svg", { width: "12", height: "6", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("path", { d: "M.6.6L6 5.4 11.4.6", stroke: "#1F1F1F", strokeLinecap: "round", strokeLinejoin: "round" }))));
});
var templateObject_1;
//# sourceMappingURL=Select.js.map